<div class="process-details-container">
  <app-technician-data
    *ngIf="loadGridConnectionComponents"
    [isReadOnly]="true"
    [isDetailsView]="isDetailsView"
    (tempConnectionConfirmed)="tempConnectionConfirmed($event)"
    (onPowerConnectionReviewSet)="powerConnectionReviewSet($event)"
    (onPowerConnectionLocationChange)="powerConnectionLocationChange($event)"
    (specialConsumerDeviceTypeChange)="onSpecialConsumerDeviceTypeChange($event)"></app-technician-data>
  <app-technical-data *ngIf="installationType === 'feedin'" [isReadOnly]="dataIsEditable ? isReadOnly : true"></app-technical-data>
  <app-siteelectricity-installation-technical-data
    *ngIf="installationType === 'construction_site_installation'"
    [isReadOnly]="dataIsEditable ? isReadOnly : true"></app-siteelectricity-installation-technical-data>

  <div class="installation-forms-section" [class.column-reverse]="showTechnicalFormFirst">
    <div>
      <app-personal-data
        *ngIf="loadInstallationApplicationComponents || loadGridConnectionComponents"
        [isReadOnly]="dataIsEditable ? isReadOnly : true"></app-personal-data>
      <h1>
        <div class="page-break">Page break</div>
      </h1>
    </div>

    <div *ngFor="let facility of facilityTypes; let index = index" class="facility-section">
      <app-facilities-data
        *ngIf="
          loadInstallationApplicationComponents && installationType !== 'construction_site_installation' && installationType !== 'feedin'
        "
        [isReadOnly]="dataIsEditable ? isReadOnly : true"
        [currentFormType]="facility"></app-facilities-data>
      <h1 *ngIf="loadInstallationApplicationComponents">
        <div class="page-break">Page break</div>
      </h1>
    </div>
  </div>

  <div>
    <app-documents-submission [isDetailsView]="true"></app-documents-submission>
  </div>

  <app-order-process
    *ngIf="loadInstallationApplicationComponents || (loadGridConnectionComponents && loadOrderProcess)"
    [isInstallationFlow]="loadInstallationApplicationComponents"
    [isConnectionFlow]="loadGridConnectionComponents"
    (executorActionEvent)="setExecutorAction($event)"
    [isReadOnly]="isReadOnly"
    [beforeApplicationUpdate]="saveApplicationData()"
    [documentsForm]="documentsComponent.documents"
    [isPersonalDataValid]="!personalData?.disableFormButtons"
    [isTechnicalDataValid]="isTechnicalDataValid"></app-order-process>

  <app-order-history
    *ngIf="loadInstallationApplicationComponents || (loadGridConnectionComponents && loadOrderProcess)"
    [pagination]="useOrderHistoryPagination"
    [applicationId]="applicationId"></app-order-history>

  <div class="text-right-align top-margin send-message-section" *ngIf="showSendMessageButton">
    <button class="action-button" label="{{ 'send-message-button-label' | translate }}" pButton (click)="sendMessage()"></button>
  </div>
  <div
    class="text-right-align top-margin send-message-section"
    *ngIf="loadInstallationApplicationComponents || loadGridConnectionComponents">
    <button class="action-button" label="Download" pButton (click)="downloadAllDocuments()"></button>
    <button class="action-button" label="Print" pButton (click)="print()"></button>
    <button
      *ngIf="showApproveAndRejectButtons"
      [disabled]="!isTempPowerReportConfirmed"
      class="action-button"
      label="{{ 'approve-application-button-label' | translate }}"
      pButton
      (click)="approveApplication()"></button>
    <button
      *ngIf="showApproveAndRejectButtons"
      class="action-button"
      label="{{ 'reject-application-button-label' | translate }}"
      pButton
      (click)="rejectApplication()"></button>
    <button
      *ngIf="showUpdateAndWithdrawButton"
      [disabled]="!isDraftRejectedRequest || !powerConnectionFormValid"
      class="action-button"
      label="{{ 'update-application-button-label' | translate }}"
      pButton
      (click)="updateTechnicianData()"></button>
    <button
      *ngIf="showUpdateAndWithdrawButton"
      [disabled]="!isDraftRejectedRequest"
      class="action-button"
      label="{{ 'withdraw-application-button-label' | translate }}"
      pButton
      (click)="withdrawApplication()"></button>
  </div>
</div>
<app-loader *ngIf="isLoading"></app-loader>
